import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Badge,
  Popconfirm,
  Empty,
  Select,
  Tabs
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import CustomTable from '../../components/table/custom-table';
import { useCreatedSort, withCreatedColumn } from '../../shared/functional/created-sort';
import AddEditHighlightBoxDialog from "./AddEditHighlightBoxDialog";
import { groupType, PREVIEW_TYPE, USER_GROUP_OPTIONS } from "../../constants/app-constants";
import highlightBoxService from "../../services/highlight-box-service";
import arrayMove from 'array-move';
import SortableList from "../../components/sort/sortable-list";
import userService from "../../services/user-service";
import { openWebsitePreview } from "../../utils/preview-utils";

const { Panel } = Collapse;
const { Option } = Select;
const { TabPane } = Tabs;

function callback(key) {
  // console.log(key);
}
const previewUrl = process.env.REACT_APP_PREVIEW_ENDPOINT;

const HighlightBox = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({ title: null, status: null });
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, rowPerPage: 10, rowCount: 0 });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [userList, setUserList] = useState([]);

  // NMU-419: one independent display config (up to 4 highlight cards) per
  // audience tab, keyed by USER_GROUP_OPTIONS value. activeGroup drives which
  // group the header's Clear/Save/Preview buttons and "Add to display"
  // operate on — each tab genuinely manages its own list, not a shared one.
  const [activeGroup, setActiveGroup] = useState(USER_GROUP_OPTIONS[0].value);
  const [displayByGroup, setDisplayByGroup] = useState({});
  const displayList = displayByGroup[activeGroup] || [];
  const setDisplayList = (list) => {
    setDisplayByGroup((prev) => ({ ...prev, [activeGroup]: list }));
  };


  /*
    NMU-580: the วันที่/เวลาสร้าง column and the sort behind it.

    The server does the ordering — this table shows one page of many — so a
    click re-runs the search in the new order, back on page 1: the newest
    record is not on page 3 of the same list read the other way round.
  */
  const { sort, createdColumn, onChangeTable } = useCreatedSort((next) =>
    doSearch(1, { condition, sort: next }));

  const columns = [
    {
      key: 'title',
      align: 'left',
      title: 'ชื่อไฮไลท์',
      dataIndex: 'title',
      render: (text) => (
        <span>{text.titleTH}</span>
      )
    },
    // {
    //   title: "รูปภาพ",
    //   key: "image",
    //   render: ({ highlightBoxId, attachImage }) => {
    //     return (
    //       attachImage && attachImage?.originalFilename ? 
    //         (<img className="w-100"
    //           src={fileUtils.getFileRenderUrl( groupType.HIGHLIGHT_BOX, highlightBoxId, attachImage.originalFilename)}>
    //         </img>) : null
    //     );
    //   },
    // },
    {
      title: "ลิงค์",
      dataIndex: "url",
      key: "url",
      render: (data) => {
        return (
          <a
            href="#"
            onClick={() => {
              window.open(
                data,
                'winname',
                'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no'
              );
            }}>
            ลิงค์
          </a>
        );
      },
    },
    {
      title: 'จำนวนผู้เข้าชม',
      dataIndex: 'totalView',
      key: 'totalView',
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Badge color={text ? '#4A9A0F' : '#CBCACA'} className="text-nowrap" text={text ? 'Online' : 'Offline'} />
      ),
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },

    {
      title: 'ดำเนินการ',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <Space size="middle">
          <a onClick={() => onClickEdit(record)} className="pe-3 border-end">
            <Icon.Edit size={18} />
          </a>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(record.highlightBoxId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก" >
            <a >
              <Icon.Trash size={18} />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await userService.search();
      setUserList(response.list);
    }
    initData();
    doSearch(1);
    doSearchDisplay();
  }, []);

  useEffect(() => {
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch(1);
  };

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  }

  /**
   * @param currentPage page to land on, 1 to start over.
   * @param overrides   NMU-529: search with these filters instead of the ones in
   *   state. setCondition only takes effect on the next render, so a caller that
   *   resets the filters and searches in the same handler would otherwise re-run
   *   the search it just cleared.
   */
  const doSearch = async (currentPage, overrides) => {
    try {
      const activeSort = overrides && overrides.sort ? overrides.sort : sort;
      const newPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
        // NMU-580: the order travels with the page — see created-sort.js.
        ...activeSort,
      };

      dispatch(appLoaderAction.enable());

      // NMU-528: keywordList is no longer a search condition. The backend
      // skips the criterion when it is absent, so nothing else changes.
      const activeCondition = overrides ? overrides.condition : condition;

      const newCondition = { title: activeCondition.title, status: activeCondition.status, createBy: activeCondition.createBy }
      const result = await highlightBoxService.search(newCondition, newPaginate);
      setDataList(result.list);
      setPagination(result.pagination ? result.pagination : newPaginate);
      setSelectedRowKeys([]);
      setSelectedRows([]);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  /**
   * NMU-529: clearing the filters has to re-run the search, not just empty the
   * inputs — otherwise the table keeps showing the previous result set while the
   * form claims no filter is applied. Back to page 1, since the record the user
   * was looking at on page 3 of a filtered list is somewhere else entirely in
   * the full one.
   */
  const onClearSearch = () => {
    const cleared = { title: null, status: null, createBy: null };
    setCondition(cleared);
    doSearch(1, { condition: cleared });
  }

  const onClickEdit = (record) => {
    try {
      dispatch(appLoaderAction.enable());
      setEditData(record);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onConfirmDelete = (id) => {
    onDelete(id);
  }

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await highlightBoxService.remove({ deleteIds: [id] });
      dispatch(appLoaderAction.disale());
      notifyUtitls.deleted('สำเร็จ', 'ลบข้อมูลสำเร็จ');
      doSearch(1);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const rowSelection = () => {
    return {
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedRows(selectedRows);
        setSelectedRowKeys(selectedRowKeys);
      },
      selectedRowKeys,
    };
  }

  // NMU-419: loads every group's display list up front (5 parallel requests)
  // so switching tabs is instant and doesn't need a fetch each time.
  const doSearchDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      const results = await Promise.all(
        USER_GROUP_OPTIONS.map((g) => highlightBoxService.getDisplay({ userGroup: g.value }))
      );
      const byGroup = {};
      USER_GROUP_OPTIONS.forEach((g, i) => {
        byGroup[g.value] = results[i].list || [];
      });
      setDisplayByGroup(byGroup);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  // NMU-419: re-fetch just the active tab's group (used by "clear" and after a save).
  const doSearchDisplayForActiveGroup = async () => {
    try {
      dispatch(appLoaderAction.enable());
      const result = await highlightBoxService.getDisplay({ userGroup: activeGroup });
      setDisplayList(result.list || []);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  /**
 * NMU-435: raised from 4 to 6 per user group.
 *
 * The cap and the heading that advertises it used to be two separate literals;
 * deriving the heading from this constant keeps them in step.
 */
const MAX_DISPLAY_PER_GROUP = 6;

const onAddToDisplay = () => {
    if (selectedRows.length === 0) {
      notifyUtitls.warning('เพิ่มการแสดงไฮไลท์', 'กรุณาเลือกไฮไลท์อย่างน้อย 1 รายการ');
    } else if (displayList.length + selectedRows.length > MAX_DISPLAY_PER_GROUP) {
      notifyUtitls.warning('เพิ่มการแสดงไฮไลท์', `เพิ่มการแสดงไฮไลท์เกิน ${MAX_DISPLAY_PER_GROUP} ไฮไลท์`);
    } else {
      const compare = selectedRows.filter((item) => {
        return displayList.findIndex((highlightBox) => highlightBox.highlightBoxId === item.highlightBoxId) < 0;
      });
      const newDisplayList = [...displayList, ...compare];

      setDisplayList(newDisplayList);
      setSelectedRows([]);
      setSelectedRowKeys([]);
    }
  }

  const onSaveDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      await highlightBoxService.saveDisplay({ listBean: displayList, userGroup: activeGroup });

      dispatch(appLoaderAction.disale());
      notifyUtitls.success('สำเร็จ', 'บันทึกการแสดงผลไฮไลท์สำเร็จ');
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onClearDisplay = () => {
    doSearchDisplayForActiveGroup();
  }

  const onRemoveDisplay = (highlightBoxId) => {
    const newList = [...displayList];
    const index = displayList.findIndex((item) => item.highlightBoxId === highlightBoxId);
    newList.splice(index, 1);
    setDisplayList(newList);
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setDisplayList(arrayMove(displayList, oldIndex, newIndex));
  };

  const onPreview = async () => {
    try {
      dispatch(appLoaderAction.enable());

      // dispatch(highlightBoxPreviewAction.addHighlightBoxPreview(displayList));

      await openWebsitePreview({ type: PREVIEW_TYPE.highlightBox, listBean: displayList });
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  }

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null
      }
    });
  };

  return (
    <div>
      <h2 className="color-primary-title">ไฮไลท์</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>ไฮไลท์</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <Button type="primary" onClick={() => onAdd()}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มไฮไลท์
        </Button>
        <div className="d-flex align-items-center">
          {/* NMU-419: which group these buttons act on — there's no other cue
              once the collapse panel below is closed. */}
          <span className="text-muted me-2">
            กลุ่ม: {USER_GROUP_OPTIONS.find((g) => g.value === activeGroup)?.label}
          </span>
          <Button className="btn-gray" onClick={() => onClearDisplay()}>
            ล้างค่าการแสดงผลไฮไลท์
          </Button>
          <Button type="primary" className="mx-2" onClick={() => onSaveDisplay()}>
            <Icon.Save className="me-1" size={18} /> บันทึกการแสดงผลไฮไลท์
          </Button>
          <Button className="mx-2 btn-line" onClick={() => onPreview()}>
            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
          </Button>
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อไฮไลท์" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  {/* NMU-528: no คีย์เวิร์ด filter here. Keywords are something
                      an editor sets on a highlight in the add/edit dialog — they
                      were never a useful way to find one. The dialog keeps its
                      keyword input. */}
                  <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        // style={{ width: 200 }}
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect('createBy')}
                      >
                        {renderOptionUser()}

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="สถานะ" className="mb-0">
                      <Select name="status" value={condition.status} onChange={onChangeSelect('status')}>
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch(1)}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>

        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header={`การแสดงผลไฮไลท์ (ได้สูงสุด ${MAX_DISPLAY_PER_GROUP} ไฮไลท์ต่อกลุ่มผู้ใช้งาน)`} key="1">
            {/* NMU-419: one tab per audience — each independently manages and
                displays its own up-to-4-card list. The header's Clear/Save/
                Preview buttons above act on whichever tab is active. */}
            <Tabs activeKey={activeGroup} onChange={setActiveGroup}>
              {USER_GROUP_OPTIONS.map((g) => (
                <TabPane tab={g.label} key={g.value}>
                  {(displayByGroup[g.value] || []).length ? (
                    <SortableList
                      axis={'x'}
                      items={displayByGroup[g.value] || []}
                      onSortEnd={onSortEnd}
                      onRemove={onRemoveDisplay}
                      groupValue={groupType.HIGHLIGHT_BOX}
                    />
                  ) : (
                    <Empty />
                  )}
                </TabPane>
              ))}
            </Tabs>
          </Panel>
        </Collapse>

        <div>
          <Button type="primary" className="mx-2" onClick={() => onAddToDisplay()}>
            <Icon.Plus className="me-1" size={18} /> เพิ่มการแสดงผลไฮไลท์
          </Button>
        </div>

        <CustomTable
          rowSelection={{
            type: 'checkbox',
            ...rowSelection(),
          }}
          rowKey="highlightBoxId"
          tableName="highlightBoxTable"
          columns={withCreatedColumn(columns, createdColumn)}
          onChangeTable={onChangeTable}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditHighlightBoxDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}></AddEditHighlightBoxDialog>
    </div>
  );
};

export default HighlightBox;
